import { env } from '../../env';

interface Contact {
   name: string;
   email: string;
   role?: string;
}
export function getContactPersons(): Contact[] {
   const contactsEnv = env.REACT_APP_CONTACTS;

   if (!contactsEnv) {
      console.warn('REACT_APP_CONTACTS environment variable is not defined');
      return [];
   }

   try {
      const contacts = contactsEnv.split('|').reduce((pers, curr) => {
         if (!curr.trim()) return pers;

         const [name = 'N/A', email = 'N/A', role = undefined] = curr
            .replaceAll('_', ' ')
            .split(',')
            .map((item) => item.trim());

         if (name !== 'N/A' && email !== 'N/A') {
            pers.push({ name, email, role });
         }

         return pers;
      }, [] as Contact[]);

      return contacts;
   } catch (error) {
      console.error('Error parsing REACT_APP_CONTACTS:', error);
      return [];
   }
}
